import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairportcab() {



const cardData = {
  keyword: " Navi Mumbai Airport Cab Service",

headingDescription: "Velocity Cab provides reliable and comfortable Navi Mumbai Airport cab service, ensuring seamless and stress‑free pickups and drop‑offs to and from **Chhatrapati Shivaji Maharaj International Airport (Mumbai Airport)** and **Navi Mumbai’s local terminals**. Our professional drivers, well‑maintained vehicles, and punctual service make airport travel easy for business travelers, families, tourists, and daily commuters. We offer flexible booking options including one‑way transfers, round trips, and customizable travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and premium cars suitable for all travel needs. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Navi Mumbai Airport cab services.",

topPlaces: [
  {
    title: "Inorbit Mall Navi Mumbai",
    description: "Inorbit Mall is a popular shopping and entertainment destination in Navi Mumbai. Travelers using Navi Mumbai Airport cab service can conveniently stop here for shopping, dining, and leisure activities either before departure or after arrival. The mall houses a variety of retail brands, eateries, and a cinema, making it ideal for families and groups."
  },
  {
    title: "Sagar Vihar Park",
    description: "Sagar Vihar Park is a scenic waterfront park on Palm Beach Road in Navi Mumbai. Visitors arriving or departing via airport cab can relax here, enjoy peaceful sea views, take leisurely walks, and capture beautiful photographs. It’s a great spot for a serene break before or after your flight."
  },
  {
    title: "Pandavkada Waterfall",
    description: "Pandavkada Waterfall is a natural attraction near Navi Mumbai, best visited during the monsoon season. Travelers using our airport cab service can take a short detour to enjoy the lush greenery, cascading waters, and refreshing ambiance. The waterfall is perfect for nature lovers and photography enthusiasts."
  },
  {
    title: "Central Park Kharghar",
    description: "Central Park in Kharghar is one of the largest open green spaces in Navi Mumbai, featuring gardens, walkways, and panoramic views. Airport cab travelers can enjoy a peaceful visit here to relax, enjoy a picnic, or capture scenic photos in a tranquil environment."
  },
  {
    title: "Karnala Bird Sanctuary",
    description: "Karnala Bird Sanctuary near Panvel is a great destination for nature and wildlife enthusiasts. Travelers using Navi Mumbai Airport cabs can enjoy a comfortable ride to the sanctuary to spot diverse bird species, trek forest trails, and visit the historic Karnala Fort. It’s ideal for outdoor adventure and nature exploration."
  },
  {
    title: "Utsav Chowk, Kharghar",
    description: "Utsav Chowk is a well‑known landmark in Kharghar noted for its architectural design and relaxed ambiance. Visitors arriving or departing via airport cab can make a quick stop here for photos, light refreshments, and a leisurely stroll around the area."
  },
  {
    title: "Nerul Hills Viewpoint",
    description: "Nerul Hills Viewpoint offers panoramic views of Navi Mumbai, housing scenic landscapes and refreshing breezes. Travelers using airport cab services can enjoy a short stop here to capture beautiful vistas, especially during sunrise or sunset."
  },
  {
    title: "Belapur Fort",
    description: "Belapur Fort is a historic site near Navi Mumbai that provides an interesting glimpse into the region’s past. Airport cab travelers can visit the fort to explore its ancient structures, enjoy the surrounding views, and learn about local history."
  },
  {
    title: "Botanical Garden Kharghar",
    description: "Botanical Garden in Kharghar is a well‑landscaped park with themed sections, sculptures, and colorful flower beds. Visitors using Navi Mumbai airport cabs can enjoy a peaceful walk, take photos, and relax amidst nature’s beauty before or after their flight."
  },
  {
    title: "Balaji Hills Park",
    description: "Balaji Hills Park is a popular recreational spot in Navi Mumbai offering open green spaces, walking paths, and panoramic views of the city. Airport cab travelers can enjoy fresh air, scenic surroundings, and a short relaxing stop during their journey to or from the airport."
  }
],



services: [
{
name: "Navi Mumbai Airport Cab Service",
description: "Navi Mumbai Airport cab service offers reliable and comfortable transportation for passengers traveling to and from the airport. This service ensures timely pickups and drops with professional drivers and well-maintained vehicles. It is ideal for business travelers, families, and tourists. Customers can choose from sedan, SUV, and premium cab options. Transparent pricing ensures no hidden charges. 24x7 availability adds convenience for all flight schedules. It ensures a smooth and stress-free airport travel experience."
},
{
name: "Navi Mumbai Airport Cab",
description: "Navi Mumbai Airport cab provides safe and efficient transportation for airport transfers with comfortable seating and professional drivers. This service is perfect for both pickup and drop requirements. Vehicles are clean and well-maintained for a pleasant journey. Timely service ensures you never miss your flight. Transparent pricing helps in easy budgeting. Flexible booking options make travel convenient. It is a trusted cab option for airport travel."
},
{
name: "Navi Mumbai Airport Taxi Service",
description: "Navi Mumbai Airport taxi service offers dependable transportation with well-maintained vehicles and experienced drivers. This service is ideal for airport transfers with punctual pickups and smooth rides. Customers can select from various vehicle options based on their needs. Transparent billing ensures no hidden costs. Flexible booking options allow easy scheduling. It is suitable for both local and outstation travel. It ensures a comfortable journey."
},
{
name: "Navi Mumbai Airport Taxi",
description: "Navi Mumbai Airport taxi provides quick and convenient transportation for passengers traveling to or from the airport. Vehicles are clean and comfortable for all types of journeys. Professional drivers ensure safe and timely service. Ideal for business travel and personal trips. Transparent pricing ensures clarity in fares. Easy booking options make it convenient. It is a reliable choice for airport taxi services."
},
{
name: "Cab Service in Navi Mumbai Airport",
description: "Cab service in Navi Mumbai Airport offers efficient transportation solutions for travelers looking for reliable airport connectivity. This service includes pickup and drop options with professional drivers. Vehicles are maintained for comfort and safety. Transparent pricing ensures no hidden charges. Flexible booking options add convenience. It is ideal for frequent flyers and tourists. It ensures hassle-free airport transfers."
},
{
name: "Navi Mumbai Airport Taxi Booking",
description: "Navi Mumbai Airport taxi booking provides an easy way to reserve your cab with instant confirmation. Customers can book online or via phone for quick service. Multiple vehicle options are available based on travel needs. Professional drivers ensure safe and timely pickups. Transparent pricing ensures clarity in billing. Flexible scheduling makes travel planning easy. It ensures a seamless booking experience."
},
{
name: "Navi Mumbai Airport Cab Booking",
description: "Navi Mumbai Airport cab booking allows customers to secure their ride quickly and conveniently. This service provides instant booking confirmation with multiple vehicle choices. Professional drivers ensure punctual pickups and smooth journeys. Transparent pricing ensures no hidden charges. Flexible booking options enhance convenience. It is ideal for both airport and outstation travel. It offers a hassle-free booking process."
},
{
name: "Cab from Navi Mumbai Airport",
description: "Cab from Navi Mumbai Airport offers reliable transportation to various destinations including Mumbai, Pune, and nearby cities. This service is ideal for travelers looking for safe and comfortable rides after landing. Vehicles are well-maintained and suitable for long-distance travel. Professional drivers ensure smooth journeys. Transparent pricing ensures no hidden costs. Flexible booking options make travel easy. It is a convenient travel option."
},
{
name: "Navi Mumbai Airport Car Rental",
description: "Navi Mumbai Airport car rental service offers flexible travel options for customers who prefer private transportation. Customers can choose from a wide range of vehicles including sedan, SUV, and luxury cars. Well-maintained vehicles ensure a smooth ride. Professional drivers ensure safety and comfort. Transparent pricing ensures clear billing. Flexible rental plans suit different travel needs. It is ideal for airport and outstation travel."
},
{
name: "Navi Mumbai Airport Pickup Cab",
description: "Navi Mumbai Airport pickup cab service ensures timely pickup from the airport with professional drivers who track flight schedules. This service is ideal for passengers arriving at any time of the day or night. Vehicles are clean and comfortable for a relaxing journey. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It ensures a stress-free airport pickup experience."
},
{
name: "Navi Mumbai Airport Drop Taxi",
description: "Navi Mumbai Airport drop taxi service provides reliable transportation to the airport with timely pickups to ensure you never miss your flight. This service is ideal for early morning and late-night departures. Vehicles are well-maintained and comfortable. Professional drivers ensure smooth and safe rides. Transparent pricing ensures no hidden costs. Flexible booking options enhance convenience. It ensures a worry-free airport drop experience."
},
{
name: "Navi Mumbai Airport Taxi Fare",
description: "Navi Mumbai Airport taxi fare is designed to be transparent and affordable for all travelers. Pricing depends on vehicle type, distance, and trip requirements. Customers receive complete fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It helps in easy travel planning."
},
{
name: "Cheap Cab Navi Mumbai Airport",
description: "Cheap cab Navi Mumbai Airport offers budget-friendly transportation for passengers looking for economical travel. This service ensures comfortable rides at affordable rates. Vehicles are clean and well-maintained for safe journeys. Professional drivers ensure smooth service. Transparent pricing ensures no hidden costs. Flexible booking options add convenience. It is ideal for budget-conscious travelers."
},
{
name: "Best Cab Service Navi Mumbai Airport",
description: "Best cab service Navi Mumbai Airport provides high-quality transportation with a focus on comfort, safety, and reliability. This service is widely preferred by customers for its professional drivers and well-maintained vehicles. Transparent pricing ensures fair fares. Flexible booking options enhance convenience. Suitable for all types of travel needs. It ensures a premium and dependable airport travel experience."
},
{
name: "Navi Mumbai Airport Taxi Booking Online",
description: "Navi Mumbai Airport taxi booking online allows customers to book their cab easily from anywhere. Instant confirmation ensures quick travel planning. Customers can compare vehicle options and fares. Professional drivers ensure safe and timely service. Transparent pricing avoids hidden charges. Flexible booking options enhance convenience. It is the best way to book airport cabs online."
},
{
name: "Navi Mumbai Airport Pickup and Drop Cab",
description: "Navi Mumbai Airport pickup and drop cab service offers complete airport transfer solutions for both arrival and departure. This service ensures timely and reliable transportation with professional drivers. Vehicles are clean and comfortable. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is ideal for regular travelers. It ensures a smooth airport journey."
},
{
name: "Navi Mumbai Airport Taxi 24 Hours",
description: "Navi Mumbai Airport taxi 24 hours service provides round-the-clock transportation for all flight schedules. This service is ideal for late-night and early-morning travel. Vehicles are available at any time with professional drivers. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It ensures reliable service anytime. It is perfect for 24x7 airport travel."
},
{
name: "Navi Mumbai Airport AC Taxi Service",
description: "Navi Mumbai Airport AC taxi service offers comfortable and air-conditioned travel for passengers seeking a premium experience. Vehicles are clean and equipped with AC for a pleasant journey. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden charges. Flexible booking options enhance convenience. It is ideal for comfortable airport travel."
},
{
name: "Navi Mumbai Airport SUV Cab",
description: "Navi Mumbai Airport SUV cab service provides spacious and comfortable vehicles for group travel and family journeys. This service is ideal for passengers with extra luggage. Vehicles are powerful and suitable for long-distance travel. Professional drivers ensure safe and smooth rides. Transparent pricing ensures clarity in fares. Flexible booking options make it convenient. It is a great option for SUV travel."
},
{
name: "Navi Mumbai Airport Sedan Taxi",
description: "Navi Mumbai Airport sedan taxi service offers economical and comfortable travel for individuals and small families. Sedans provide smooth rides with good mileage and comfort. Vehicles are well-maintained and clean. Professional drivers ensure timely and safe service. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is a great choice for budget-friendly travel."
},
{
name: "Navi Mumbai Airport to Pune Cab",
description: "Navi Mumbai Airport to Pune cab service provides reliable intercity travel with comfortable vehicles and experienced drivers. This service is ideal for business travel, family trips, and airport transfers. Customers can choose from sedan, SUV, and premium cab options. Timely pickups ensure smooth travel. Transparent pricing ensures no hidden charges. Flexible booking options add convenience. It ensures a comfortable journey from airport to Pune."
},
{
name: "Navi Mumbai Airport to Mumbai Cab",
description: "Navi Mumbai Airport to Mumbai cab service offers quick and reliable transportation to all parts of Mumbai. This service is ideal for travelers needing city transfers. Vehicles are well-maintained and comfortable. Professional drivers ensure timely pickups and safe rides. Transparent pricing ensures no hidden charges. Flexible booking options enhance convenience. It ensures smooth city travel."
},
{
name: "Navi Mumbai Airport to Thane Cab",
description: "Navi Mumbai Airport to Thane cab service provides comfortable and reliable travel between airport and Thane. This service is suitable for both personal and business trips. Vehicles are well-maintained for smooth journeys. Professional drivers ensure timely and safe service. Transparent pricing ensures no hidden costs. Flexible booking options make it convenient. It ensures a hassle-free journey."
},
{
name: "Navi Mumbai Airport to Lonavala Cab",
description: "Navi Mumbai Airport to Lonavala cab service offers scenic and comfortable travel for tourists and travelers. This service is ideal for weekend trips and holiday travel. Vehicles are well-maintained and suitable for highway travel. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden charges. Flexible booking options enhance convenience. It ensures a relaxing journey."
},
{
name: "Navi Mumbai Airport Transfer Taxi",
description: "Navi Mumbai Airport transfer taxi service provides seamless transportation between airport and multiple destinations. This service ensures timely and efficient transfers with professional drivers. Vehicles are clean and comfortable for a pleasant journey. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is ideal for both local and outstation travel. It ensures a smooth transfer experience."
}
],

tableData: [
["Navi Mumbai Airport Cab Service","Navi Mumbai Airport Taxi Service"],
["Navi Mumbai Airport Cab Booking","Navi Mumbai Airport Taxi Booking"],
["Cheap Cab Navi Mumbai Airport","Best Cab Service Navi Mumbai Airport"],
["Navi Mumbai Airport SUV Cab","Navi Mumbai Airport Sedan Taxi"],
["Navi Mumbai Airport to Pune Cab","Navi Mumbai Airport Transfer Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Airport Transfers",
    WhyChoosedescription: "Velocity Cabs offers dependable Navi Mumbai Airport cab service for timely pickup and drop, ensuring smooth and stress-free airport travel for all passengers."
  },
  {
    WhyChooseheading: "Experienced Airport Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with Navi Mumbai Airport routes, terminals, and surrounding highways, ensuring timely arrivals and efficient navigation."
  },
  {
    WhyChooseheading: "Transparent Airport Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Navi Mumbai Airport cab bookings. Customers receive complete fare details including toll charges and parking if applicable."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport cab service operates 24/7. Whether your flight is early morning or late night, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Flexible Pickup & Drop Options",
    WhyChoosedescription: "Velocity Cabs offers flexible airport travel options including pickup, drop, one-way service, and round-trip airport transfers."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Navi Mumbai Airport cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Navi Mumbai Airport cab service?", answer: "Yes, Velocity Cabs provides reliable cab services for Navi Mumbai Airport pickup and drop." },
  { question: "Is airport cab service available 24 hours?", answer: "Yes, our Navi Mumbai Airport cab service operates 24/7." },
  { question: "Which vehicles are available for airport transfer?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way airport cab?", answer: "Yes, we provide one-way airport pickup and drop services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book airport cab online?", answer: "Yes, customers can easily book Navi Mumbai Airport cab services online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and offices across Navi Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during peak travel hours." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, we provide airport transfer services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback:
      "Quick and smooth airport transfer experience from Navi Mumbai. The cab arrived on time, was clean, and the ride felt very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Navi Mumbai Airport cab service was very reliable and well-organized. The journey was punctual, safe, and completely hassle-free.",
    rating: 5
  }
];




















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const naviMumbaiAirportCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Navi Mumbai Airport Cab Service | Velocity Cabs",
  "description": "Book a private cab from Navi Mumbai Airport for city transfers or outstation travel. AC, Sedan, and SUV taxis available for airport pickup, drop, and one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Navi Mumbai Airport Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Navi Mumbai Airport",
        "description": "Private cab from Navi Mumbai Airport for one-way travel with AC, SUV, or Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Cab from Navi Mumbai Airport",
        "description": "Comfortable round-trip cab service from Navi Mumbai Airport with private AC, SUV, or Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Airport Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Navi Mumbai Airport for city transfers or outstation travel. AC, Sedan, and SUV taxis available for airport pickup, drop, and one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(naviMumbaiAirportCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/117.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcab;